import React from 'react'
import { GeneralTable } from 'modules/app/styles'
import { ReactComponent as EditIcon } from 'assets/images/icons/edit.svg'
import { getEmail } from '.'
import { Badge } from 'modules/mainmenu/pages/styles'
import Avatar from 'modules/auth/components/Avatar'

export const Active = (props) => {
  return (
    <GeneralTable responsive>
      <thead>
        <tr>
          {props.my_membership.user_type === 'admin' && <th></th>}
          <th style={{ minWidth: 150 }}> Name </th>
          <th style={{ minWidth: 150 }}> Email </th>
          <th style={{ minWidth: 300, maxWidth: 300 }}> User Groups </th>
        </tr>
      </thead>
      <tbody>
        {props.memberList.length === 0 && (
          <tr>
            <td colSpan={4}> No members. </td>
          </tr>
        )}
        {props.memberList.map((member, index) => {
          let team_count = 0,
            team_limit = 2,
            myTeamsIds = member.teams.map((t) => t.id)
          return (
            <tr key={index} id={`member_${member.id}`}>
              {props.my_membership.user_type === 'admin' && (
                <td>
                  {!!!member.is_active && ''}
                  {!!member.is_active && member.user_id === props.user.id && 'Me'}
                  {!!member.is_active && member.invite_status !== 'owned' && member.user_id !== props.user.id && (
                    <a href='/' onClick={(e) => props.onShowEditMember(e, member)}>
                      <EditIcon />
                    </a>
                  )}
                </td>
              )}
              <td>
                <div className='d-flex align-items-center'>
                  {member.user && (
                    <span className='mr-2'>
                      <Avatar user={member.user} />
                    </span>
                  )}
                  <div>
                    <div className='d-flex align-items-center'>
                      {member.user ? member.user.name : member.name}
                      {member.user_type === 'admin' && member.invite_status !== 'owned' && <Badge className='blue'>Admin</Badge>}
                      {member.user_type === 'admin' && member.invite_status === 'owned' && <Badge className='green'>Owner</Badge>}
                    </div>
                    <small className='text-muted'>{member.position}</small>
                  </div>
                </div>
              </td>
              <td>{getEmail(member)}</td>
              <td>
                <span>Everyone</span>
                {member.teams.map((team, i) => {
                  team_count++
                  return team_count <= team_limit && <span key={i}>, {team.name} </span>
                })}
                {member.team_membership
                  .filter((t) => myTeamsIds.indexOf(t.team_id) === -1)
                  .map((membership, i) => {
                    team_count++
                    return team_count <= team_limit && <span key={i}>, {membership.team.name} </span>
                  })}
                {team_count > team_limit && <strong> +{team_count - team_limit} </strong>}
              </td>
            </tr>
          )
        })}
      </tbody>
    </GeneralTable>
  )
}
